const urls = {
  IMAGES: 'https://s3.amazonaws.com/finvoice-tenants/finvoice-app',
  STAGING: 'http://platformstaging.finvoice.co',
}

export default urls
